<div class="proximity-overlay" role="region" aria-label="Simulation replay overlay">
  <header class="proximity-overlay__banner">
    <span class="proximity-overlay__banner-dot" aria-hidden="true"></span>
    <div class="proximity-overlay__banner-text">
      <span class="proximity-overlay__banner-title">{{ title }}</span>
    </div>
    
    <button type="button" class="proximity-overlay__icon-button" aria-label="Close simulation overlay"
      title="Close simulation" (click)="close.emit()">×</button>
  </header>

  <div class="proximity-overlay__telemetry-rail"
    [class.proximity-overlay__telemetry-rail--expanded]="telemetryExpanded">
    @if (!isPerpetrator) {
    <aside class="proximity-overlay__event-log" aria-label="Advocate event log">
        <header><h4>Advocate event log</h4><span>{{ logCount }} entries</span></header>
        <ol #eventLogList>
          @for (entry of eventLogs; track trackLog($index)) {
          <li>
            <div><time>{{ entry.receivedAt | date:'HH:mm:ss' }}</time><span class="proximity-overlay__badge" [class]="logBadgeClass(entry)">{{ logBadgeLabel(entry) }}</span></div>
            <p>{{ entry.message }}</p>
          </li>
          } @empty {
          <li class="proximity-overlay__empty">Replay started. Waiting for the first check-in.</li>
          }
    </ol>
    </aside>
    }
  <div class="proximity-overlay__stage">
    <div class="proximity-overlay__watches" aria-label="Watch screens">
      <article class="proximity-overlay__watch-card proximity-overlay__watch-card--survivor">
        <div class="proximity-overlay__watch-face" [class.proximity-overlay__watch-face--alert]="isSurvivorAlerting">
          <div class="proximity-overlay__watch-screen">
            <time class="proximity-overlay__clock">{{ now | date:'HH:mm' }}</time>
            <span class="proximity-overlay__watch-name"><span class="proximity-overlay__watch-dot"></span>{{ survivorName }}</span>
            <div class="proximity-overlay__alert">
              <div class="proximity-overlay__alert-icon">!</div>
              <h4>{{ survivorAlertTitle }}</h4>
              <p>{{ survivorAlertBody }}</p>
              <button type="button" class="proximity-overlay__dismiss" (click)="dismissAlert('survivor')">Dismiss</button>
            </div>
          </div>
        </div>
      </article>
      <article class="proximity-overlay__watch-card proximity-overlay__watch-card--perpetrator">
        <div class="proximity-overlay__watch-face" [class.proximity-overlay__watch-face--alert]="isPerpetratorAlerting">
          <div class="proximity-overlay__watch-screen">
            <time class="proximity-overlay__clock">{{ now | date:'HH:mm' }}</time>
            <span class="proximity-overlay__watch-name"><span class="proximity-overlay__watch-dot"></span>{{ perpetratorName }}</span>
            <div class="proximity-overlay__alert">
              <div class="proximity-overlay__alert-icon">!</div>
              <h4>{{ perpetratorAlertTitle }}</h4>
              <p>{{ perpetratorAlertBody }}</p>
              <button type="button" class="proximity-overlay__dismiss" (click)="dismissAlert('perpetrator')">Dismiss</button>
            </div>
          </div>
        </div>
      </article>
    </div>
  </div>
  </div>

  <footer class="proximity-overlay__playback">
    <button type="button" class="proximity-overlay__playback-primary" (click)="close.emit()">
      Stop
    </button>
    <button type="button" class="proximity-overlay__playback-button" (click)="editSimulation.emit()">Change scenario</button>
    <div class="proximity-overlay__progress" role="progressbar" aria-label="Simulation progress"
      [attr.aria-valuenow]="completedCheckIns" [attr.aria-valuemin]="0" [attr.aria-valuemax]="totalCheckIns">
      <span [style.width.%]="progressPercent"></span>
    </div>
    <span class="proximity-overlay__playback-progress">
      ({{ completedCheckIns }} / {{ totalCheckIns }})
    </span>
  </footer>
</div>
